import { Component, Input } from '@angular/core';

interface Product {
  name: string;
  description: string;
  image: string;
}

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.css']
})
export class ProductCardComponent {
  @Input() product!: Product;

}
